const comparisonData = [
  { feature: 'Templates', kakobuy: 'Advanced', excel: 'Medium', googleSheets: 'Medium' },
  { feature: 'Automation', kakobuy: 'High', excel: 'Medium', googleSheets: 'Medium' },
  { feature: 'Business Usage', kakobuy: 'Excellent', excel: 'Good', googleSheets: 'Good' },
  { feature: 'Collaboration', kakobuy: 'High', excel: 'Medium', googleSheets: 'High' },
  { feature: 'Learning Curve', kakobuy: 'Easy', excel: 'Medium', googleSheets: 'Easy' },
  { feature: 'Template Library', kakobuy: 'Extensive', excel: 'Large', googleSheets: 'Moderate' },
  { feature: 'Data Visualization', kakobuy: 'Rich', excel: 'Rich', googleSheets: 'Good' },
  { feature: 'Cloud Sync', kakobuy: 'Seamless', excel: 'Good', googleSheets: 'Excellent' },
];

const getRatingColor = (rating: string) => {
  const map: Record<string, string> = {
    Advanced: 'bg-secondary-100 text-secondary-700',
    Excellent: 'bg-secondary-100 text-secondary-700',
    Extensive: 'bg-secondary-100 text-secondary-700',
    Rich: 'bg-secondary-100 text-secondary-700',
    Seamless: 'bg-secondary-100 text-secondary-700',
    High: 'bg-accent-100 text-accent-700',
    Easy: 'bg-accent-100 text-accent-700',
    Good: 'bg-background-100 text-foreground-600',
    Medium: 'bg-background-100 text-foreground-600',
    Moderate: 'bg-background-100 text-foreground-600',
    Large: 'bg-background-100 text-foreground-600',
  };
  return map[rating] || 'bg-background-100 text-foreground-600';
};

export default function ComparisonTable() {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-4">
            Platform Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
            Vigorbuy Spreadsheet vs Alternatives
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            See how Vigorbuy Spreadsheet stacks up against traditional spreadsheet tools across key business features.
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/60">
                  <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800 whitespace-nowrap">Feature</th>
                  <th className="text-center px-6 py-4 text-sm font-semibold text-primary-600 whitespace-nowrap">
                    <div className="flex items-center justify-center gap-1.5">
                      <i className="ri-star-fill text-xs"></i>
                      Vigorbuy Spreadsheet
                    </div>
                  </th>
                  <th className="text-center px-6 py-4 text-sm font-medium text-foreground-600 whitespace-nowrap">Excel</th>
                  <th className="text-center px-6 py-4 text-sm font-medium text-foreground-600 whitespace-nowrap">Google Sheets</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, idx) => (
                  <tr key={row.feature} className={`border-b border-background-200/40 ${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/40'}`}>
                    <td className="px-6 py-3.5 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                    <td className="px-6 py-3.5 text-center">
                      <span className={`inline-block px-3 py-1 rounded-lg text-xs font-semibold ${getRatingColor(row.kakobuy)}`}>
                        {row.kakobuy}
                      </span>
                    </td>
                    <td className="px-6 py-3.5 text-center">
                      <span className={`inline-block px-3 py-1 rounded-lg text-xs font-medium ${getRatingColor(row.excel)}`}>
                        {row.excel}
                      </span>
                    </td>
                    <td className="px-6 py-3.5 text-center">
                      <span className={`inline-block px-3 py-1 rounded-lg text-xs font-medium ${getRatingColor(row.googleSheets)}`}>
                        {row.googleSheets}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}